import "./IncomingCallBanner.css";

export function callerDisplayName(call, contacts = []) {
  const callerId = Number(call?.callerUserId ?? call?.caller?.userId);
  const first = String(call?.caller?.firstName || "").trim();
  const last = String(call?.caller?.lastName || "").trim();
  const built = `${first} ${last}`.trim();
  if (built) return built;

  const fromCaller = call?.caller?.displayName;
  if (fromCaller && !/^User\s+\d+$/i.test(String(fromCaller).trim())) {
    return fromCaller;
  }

  const contact = (contacts || []).find((c) => Number(c.userId) === callerId);
  if (contact?.displayName && !/^User\s+\d+$/i.test(String(contact.displayName).trim())) {
    return contact.displayName;
  }

  if (call?.caller?.username) return call.caller.username;
  if (contact?.username) return contact.username;
  if (Number.isFinite(callerId)) return `User ${callerId}`;
  return "Incoming call";
}

export default function IncomingCallBanner({
  variant = "incoming",
  call,
  contacts = [],
  message = "Disconnected",
  busy = false,
  onAnswer,
  onDecline,
  className = "",
}) {
  if (variant === "disconnected") {
    return (
      <div
        className={`incoming-call-banner incoming-call-banner--disconnected ${className}`.trim()}
        role="status"
        aria-live="polite"
      >
        <div className="incoming-call-banner__body incoming-call-banner__body--disconnected">
          <strong>{message}</strong>
        </div>
      </div>
    );
  }

  const callLabel = call?.callType === "audio" ? "voice" : "video";
  const name = callerDisplayName(call, contacts);

  return (
    <div className={`incoming-call-banner ${className}`.trim()} role="alert" aria-live="assertive">
      <div className="incoming-call-banner__body">
        <strong>Incoming {callLabel} call</strong>
        <span>{name}</span>
      </div>
      <div className="incoming-call-banner__actions">
        <button type="button" className="incoming-call-banner__answer" onClick={onAnswer} disabled={busy}>
          {busy ? "Connecting…" : "Answer"}
        </button>
        <button
          type="button"
          className="incoming-call-banner__decline"
          onClick={onDecline}
          disabled={busy}
        >
          Decline
        </button>
      </div>
    </div>
  );
}
